// Keep in sync with src/styles/tokens.css. CSS custom properties are canonical
// for global styling; this file bridges the same palette to TS/JSX.

export const brand = {
  primary: '#01689b',
  primaryHover: '#1d7ea8',
  primaryDark: '#004a75',
  secondary: '#fefeff',

  blue: '#007bc7',
  green: '#39870C',
  greenDark: '#275937',
  red: '#d52b1e',
  redLight: '#f0806e',
  redDark: '#7c3535',
  orange: '#e17000',
  yellow: '#f9e11e',
  gold: '#ffb612',
  purple: '#42145f',
  magenta: '#ca005d',
  pink: '#f092cd',
  lime: '#76d2b6',

  text: '#01689B',
  textSecondary: '#595959',
  heading: '#535353',
  headerText: '#262626',

  navDarkBg: '#003366',
  navDarkText: '#038fdd',
} as const;

export const semantic = {
  success: brand.green,
  error: brand.red,
  warning: brand.orange,
  info: brand.blue,
  processing: brand.primary,
} as const;

// Soft tints of `brand.primary`, used for selected rows, avatar fills and
// selection bars. JSX-only, so they have no LESS counterpart.
export const primaryTint = {
  /** Avatar / badge fill. */
  soft: '#eaf2f7',
  /** Selected row and info-bar background. */
  surface: '#f3f8fb',
  /** Border that pairs with `surface`. */
  border: '#cfe0ec',
} as const;

export const chartPalette = [
  brand.purple, // #42145f
  '#a90061',
  brand.magenta, // #ca005d
  '#6b6b6b',
  brand.orange, // #e17000
  '#673327',
  brand.greenDark, // #275937
  '#777c00',
  brand.lime, // #76d2b6
  brand.primary, // #01689b
  brand.blue, // #007bc7
  '#8fcae7',
] as const;
